import { Layout } from "antd";
import { Content } from "antd/es/layout/layout";
import { Outlet } from "react-router-dom";
import BackgroundSVGs from "../auth/layout/BackgroundSVGs";

type Props = {};

const SecLayout = (props: Props) => {
  return (
    <Layout className="min-h-screen bg-white">
      <BackgroundSVGs />
      <Content className="layout-content-wrapper">
        <div className="container">
          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};
export default SecLayout;
